<template>
  <section :class="[showMask ? 'show' : '', 'mask-wrap']" @click.self="changeMask">
    <transition name="showmask-ordermodel">
      <div v-if="showMask" :class="['mask-container']">
        <header>
          <div class="thumbnail-wrap"><img :src="ScopeGoodsInfo.GoodsLogoUrl" alt="" /></div>
          <div class="text-description">
            <h3>{{ ScopeGoodsInfo.Description }}</h3>
            <p class="red-text">
              <i class="iconfont icon-renminbi"></i>
              <span>{{ TotalPrice }}</span>
            </p>
            <p class="red-text">
              <span>{{ ScopeGoodsInfo.Remarks }}</span>
            </p>
          </div>
          <div @click.stop="changeMask" class="del-icon-wrap"><i class="iconfont icon-shanchu2"></i></div>
        </header>

        <section class="select-container-wrap">
          <div class="select-item-wrap" v-if="ScopeGoodsInfo.ExtraServiceList && ScopeGoodsInfo.ExtraServiceList.length > 0 && this.groupList.length > 0">
            <template v-for="(groupName, index) in groupList">
              <div class="airport-wrap" :key="index + 1">
                <h3>{{ groupName }}</h3>
                <div class="airport-items">
                  <template v-for="(extraItem, j) in ScopeGoodsInfo.ExtraServiceList" v-if="extraItem.GroupName == groupName">
                    <button :class="[chooseExtraList.indexOf(extraItem) != -1 ? 'active' : '']" @click="chooseService(extraItem, j)" :key="j">{{ extraItem.ServiceName }}</button>
                  </template>
                </div>
              </div>
            </template>
          </div>

          <div class="goods-amount">
            <span>购买数量 :</span>
            <div class="selector">
              <i @click="subGoods(1)" :class="['iconfont', 'icon-jianhao', submitInfo.GoodsList[0].Count == 1 ? 'disabled' : '']"></i>
              <input v-model="submitInfo.GoodsList[0].Count" type="number" disabled="true" />
              <i @click="addGoods(1)" :class="['iconfont', 'icon-jiahao', submitInfo.GoodsList[0].Count > 9 ? 'disabled' : '']"></i>
            </div>
          </div>

          <div :class="['link-man-wrap']">
            <span>
              <em style="color: #E22222;">*</em>
              联系人
            </span>
            <input v-model="submitInfo.Contact" placeholder="请输入联系人" type="text" />
          </div>

          <div :class="['phone-num-wrap']">
            <span>
              <em style="color: #E22222;">*</em>
              联系电话
            </span>
            <input v-model="submitInfo.Mobile" placeholder="输入您的联系电话" type="number" />
          </div>

          <div :class="['user-site']" v-if="ScopeGoodsInfo.IsPickup">
            <span>
              <em style="color: #E22222;"></em>
              客户地址
            </span>
            <input v-model="submitInfo.Address" placeholder="包车客户请填写接送地址" type="text" />
          </div>

          <div class="date-picker" @click="setDate">
            <span>
              <em style="color: #E22222;">*</em>
              预约日期
            </span>
            <span :class="[submitInfo.Date == '' ? 'gray-text' : '']">{{ submitInfo.Date == '' ? '请选择预订日期' : submitInfo.Date }}</span>
          </div>

          <div class="time-picker" @click="setTime" v-if="ScopeGoodsInfo.IsPickup">
            <span>
              <em style="color: #E22222;">*</em>
              预约时间
            </span>
            <span :class="[submitInfo.Time == '' ? 'gray-text' : '']">{{ submitInfo.Time == '' ? '请选择具体时间' : submitInfo.Time }}</span>
          </div>

          <div class="leave-msg">
            <span>
              <em style="color: #E22222;"></em>
              备注
            </span>
            <input v-model="submitInfo.Remarks" placeholder="专车旅客请备明人数,航班或返程时间" type="text" />
          </div>
        </section>

        <footer class="mask-footer"><button @click="goToSubmitOrder">下一步</button></footer>
      </div>
    </transition>
  </section>
</template>

<script>
import baseTool from '../../utils/baseFunction';
import { mapState } from 'vuex';
export default {
  name: 'ScopeMaskOption',
  data() {
    return {
      //用户输入的资料
      submitInfo: {
        OpenId: this.$store.state.user.OpenId,
        Contact: '', // 联系人
        Mobile: '', // 联系电话
        Address: '', // 接送地址
        SetDate: '', // 最终日期+时间
        Date: '', // 日期
        Time: '', // 时间
        LuggageCount: 0, // 行李件数
        Remarks: '', // 客户备注
        Pickup: 0, // 是否接送，默认否0.
        MemberCount: 1, // 人数，默认0
        District: '', // 区域，Pickup为1时要填
        GoodsList: [
          {
            //ID, Count, Discount, Remarks, PointBounds, PointDiscount, ExtraList
            ID: 0,
            Count: 1,
            Discount: 0,
            Remarks: '',
            PointBounds: 0,
            PointDiscount: 0,
            ExtraList: [] // GoodsID, ServiceID, ServiceName, ModelID
          }
        ], // 商品列表数组
        MemberList: [] // ContactID, RealName, CardNO, Mobile, AgeType
      },
      groupList: [],
      chooseExtraList: []
    };
  },
  props: {
    showMask: {
      type: Boolean
    },
    ScopeGoodsInfo: {
      type: Object
    }
  },
  mounted() {
    this.$store.dispatch('ticket/getDefaultAddress', this.$store.state.user.OpenId);
    if (this.DefaultAddress) {
      this.submitInfo.Contact = this.DefaultAddress.Contact;
      this.submitInfo.Mobile = this.DefaultAddress.Mobile;
      this.submitInfo.Address = this.DefaultAddress.District + '-' + this.DefaultAddress.Address;
      this.submitInfo.District = this.DefaultAddress.District;
    }
    this.initGroupList();
  },
  methods: {
    createExtraListRecord(GoodsID, ServiceID, ServiceName, ModelID) {
      var obj = {
        GoodsID: GoodsID,
        ServiceID: ServiceID,
        ServiceName: ServiceName,
        ModelID: ModelID
      };
      return obj;
    },
    initGroupList() {
      var that = this;
      this.groupList = [];
      this.tmpTimer = setInterval(() => {
        if (that.ScopeGoodsInfo && that.ScopeGoodsInfo.ID == that.$route.params.id) {
          clearInterval(that.tmpTimer);
          that.submitInfo.GoodsList[0].ID = that.ScopeGoodsInfo.ID;
          if (that.ScopeGoodsInfo.ExtraServiceList && that.ScopeGoodsInfo.ExtraServiceList.length > 0) {
            for (var i = 0; i < that.ScopeGoodsInfo.ExtraServiceList.length; i++) {
              if (that.groupList.indexOf(that.ScopeGoodsInfo.ExtraServiceList[i].GroupName) == -1) {
                that.groupList.push(that.ScopeGoodsInfo.ExtraServiceList[i].GroupName);
              }
            }
            console.log('initGroupList=>', that.groupList);
          }
        }
      }, 100);
    },
    chooseService(extraItem, index) {
      let tmpIndex = this.chooseExtraList.indexOf(extraItem);
      if (tmpIndex != -1) {
        this.chooseExtraList.splice(tmpIndex, 1);
        for (let i = 0; i < this.submitInfo.GoodsList[0].ExtraList.length; i++) {
          let tmp = this.submitInfo.GoodsList[0].ExtraList[i];
          if (tmp.ServiceID == extraItem.ID) {
            this.submitInfo.GoodsList[0].ExtraList.splice(i, 1);
          }
        }
        return;
      }
      for (let i = 0; i < this.chooseExtraList.length; i++) {
        if (this.chooseExtraList[i].GroupName == extraItem.GroupName) {
          let tmpExtraRecord = this.chooseExtraList[i];
          for (let j = 0; j < this.submitInfo.GoodsList[0].ExtraList.length; j++) {
            let tmp = this.submitInfo.GoodsList[0].ExtraList[j];
            if (tmp.ServiceID == tmpExtraRecord.ID) {
              this.submitInfo.GoodsList[0].ExtraList.splice(j, 1);
            }
          }
          this.chooseExtraList.splice(i, 1);
          this.chooseExtraList.push(extraItem);
          this.submitInfo.GoodsList[0].ExtraList.push(this.createExtraListRecord(this.submitInfo.GoodsList[0].ID, extraItem.ID, extraItem.ServiceName, extraItem.ModelID));
          return;
        }
      }
      this.chooseExtraList.push(extraItem);
      this.submitInfo.GoodsList[0].ExtraList.push(this.createExtraListRecord(this.submitInfo.GoodsList[0].ID, extraItem.ID, extraItem.ServiceName, extraItem.ModelID));
    },
    computedGoodsPrice() {
      this.submitInfo.goodsName = this.airports[this.currentAir][this.currentCar].name + '-' + this.carModels[this.currentCar].name;
      switch (this.currentTicketForm) {
        case 0:
          this.submitInfo.goodsName += '-常规时间';
          break;
        case 1:
          this.submitInfo.goodsName += '-单程深夜时间';
          break;
        case 2:
          this.submitInfo.goodsName += '-往返深夜时间';
          break;
      }
      this.submitInfo.goodsPrice = this.airports[this.currentAir][this.currentCar].price + this.ticketForm[this.currentTicketForm].extra;
    },
    addGoods(inc) {
      if (this.submitInfo.GoodsList[0].Count < 10) {
        this.submitInfo.GoodsList[0].Count += inc;
      } else {
        alert('如需购买更多数量请联系客服订购,电话:8888-0777');
      }
    },
    subGoods(dec) {
      if (this.submitInfo.GoodsList[0].Count > 1) {
        this.submitInfo.GoodsList[0].Count -= dec;
      } else if (this.submitInfo.GoodsList[0].Count == 1) {
        alert('商品数量不能少于1~');
      }
    },
    changeMask() {
      this.$emit('showHideMask', 'showMask');
    },
    setDate() {
      //			var tmpDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
      var tmpDate = new Date();
      console.log(tmpDate);
      var that = this;
      this.$weui.datePicker({
        start: tmpDate, // 从今天开始
        //				defaultValue: tmpDate,
        end: baseTool.addDate(new Date(), 90),
        onConfirm(result) {
          that.submitInfo.Date = result[0].value + '-' + result[1].value + '-' + result[2].value;
        }
      });
    },
    // 跳转-------------------
    goToSubmitOrder() {
      let that = this;
      let linkManReg = /^[\u4e00-\u9fa5_a-zA-Z ]{2,20}$/,
        phoneReg = /^[1][3,4,5,7,8][0-9]{9}$/,
        linkManBoolean = linkManReg.test(this.submitInfo.Contact),
        phoneBoolean = phoneReg.test(this.submitInfo.Mobile);

      if (this.groupList.length > 0) {
        let checkOK = true;
        let Msg = '';
        this.groupList.forEach(group => {
          let tmpIndex = -1;
          for (let i = 0; i < that.chooseExtraList.length; i++) {
            if (group == that.chooseExtraList[i].GroupName) {
              tmpIndex = i;
            }
          }
          if (tmpIndex == -1) {
            Msg += '请选择：[' + group + '];';
            checkOK = false;
          }
        });
        if (!checkOK) {
          this.$Message.warning(Msg);
          return;
        }
      }

      if (this.submitInfo.Contact && this.submitInfo.Mobile && this.submitInfo.Date != '') {
        if (linkManBoolean) {
          if (phoneBoolean && this.submitInfo.Mobile.length > 7) {
            if (phoneBoolean && linkManBoolean) {
              if (this.ScopeGoodsInfo.IsPickup) {
                if (this.submitInfo.Address == '') {
                  this.$Message.warning('请填写上门接送地址！');
                  return;
                }
                if (this.submitInfo.Time == '') {
                  this.$Message.warning('请选择具体预约时间！');
                  return;
                }
              }
              this.submitInfo.MemberList = [];
              this.submitInfo.MemberList.push({
                ContactID: 0,
                RealName: that.submitInfo.Contact,
                CardNO: '',
                Mobile: that.submitInfo.Mobile,
                AgeType: '成人'
              });
              console.log('goToSubmitOrder=>submitInfo=', this.submitInfo);
              this.$router.push({
                name: 'ScopeSubmitOrder',
                params: {
                  submitInfo: this.submitInfo,
                  ScopeGoodsInfo: this.ScopeGoodsInfo,
                  chooseExtraList: this.chooseExtraList
                }
              });
            }
          } else {
            this.$Message.warning('手机号码不合法');
          }
        } else {
          this.$Message.warning('名字不合法');
        }
      } else {
        this.$Message.warning('请补充填写完整资料');
      }
    },
    setTime() {
      var _this = this;
      var hours = [],
        minites = [],
        symbol = [
          {
            label: ':',
            value: 0
          }
        ];
      if (!hours.length) {
        for (var i = 0; i < 24; i++) {
          var hours_item = {};
          hours_item.label = ('' + i).length === 1 ? '0' + i : '' + i;
          hours_item.value = i;
          hours.push(hours_item);
        }
      }
      if (!minites.length) {
        for (var j = 0; j < 60; j++) {
          var minites_item = {};
          minites_item.label = ('' + j).length === 1 ? '0' + j : '' + j;
          minites_item.value = j;
          minites.push(minites_item);
        }
      }
      this.$weui.picker(hours, symbol, minites, {
        defaultValue: [new Date().getHours() + 1, 0, 0],
        onConfirm(result) {
          _this.submitInfo.Time = result[0].label + ':' + result[2].label;
        }
      });
    }
  },
  computed: mapState({
    DefaultAddress: state => state.ticket.DefaultAddress,
    TotalPrice() {
      var that = this;
      var totalPrice = 0;
      totalPrice += this.ScopeGoodsInfo.AdultPrice * this.submitInfo.GoodsList[0].Count;
      this.chooseExtraList.forEach(obj => {
        totalPrice += obj.Price * that.submitInfo.GoodsList[0].Count;
      });
      return totalPrice;
    }
  })
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/child-components/ScopeMaskOption.vue